import { Injectable } from '@angular/core';
import { GraphQlEffectService } from '../../services/graph-ql-effect.service';
import { TrustedDeviceEntity } from '../../entities/trusted-device.entity';
import { TrustedDeviceActions } from '../actions/trusted-devices.actions';
import {
    DaveMutation, DaveMutationDeleteTrustedDeviceArgs,
    TrustedDeviceType,
} from '../../graphql-types';
import { BaseActionTypes } from '../actions/base.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

enum ErrorCodes {
    Load = 'Vertrauenswürdige Geräte Abrufen fehlgeschlagen',
    Delete = 'Vertrauenswürdiges Gerät löschen fehlgeschlagen',
}
const errorCodesByActionTypes = {
    [TrustedDeviceActions.loadfailure.type]: ErrorCodes.Load,
    [TrustedDeviceActions.deletefailure.type]: ErrorCodes.Delete,
}

@Injectable()
export class TrustedDeviceEffects {

    getTrustedDevice = this.graphQlEffectService.createGetAllEffect<{}, TrustedDeviceEntity, TrustedDeviceType>(
        'trustedDevice',
        TrustedDeviceEntity.GqlFields.join(','),
        TrustedDeviceActions.loadrequest,
        TrustedDeviceActions.loadsuccess,
        (a) => a.map(TrustedDeviceEntity.fromBackend),
        ErrorCodes.Load,
        [],
        [],
        TrustedDeviceActions.loadfailure,
    );

    // deleteTrustedDevice = this.graphQlEffectService.createDeleteOneEffect<{}, TrustedDeviceEntity, TrustedDeviceType>(
    //     'trustedDevice',
    //     TrustedDeviceEntity.GqlFields.join(','),
    //     TrustedDeviceActions.loadrequest,
    //     TrustedDeviceActions.loadsuccess,
    //     (a) => a.map(TrustedDeviceEntity.fromBackend),
    //     ErrorCodes.Load,
    //     [],
    //     [],
    //     TrustedDeviceActions.loadfailure,
    // );
    RemoveEmployeeSalaryType$ = this.graphQlEffectService.createDeleteOneEffect<DaveMutationDeleteTrustedDeviceArgs, number, DaveMutation['deleteTrustedDevice']>(
        'deleteTrustedDevice',
        TrustedDeviceEntity.GqlFields.join(','),
        TrustedDeviceActions.deleterequest,
        TrustedDeviceActions.deletesuccess,
        (v) => v.id,
        ErrorCodes.Delete,
        ['id'],
        [],
        undefined,
        TrustedDeviceActions.deletefailure,
    );
    errors = createEffect(() => this.actions$.pipe(
        ofType(TrustedDeviceActions.loadfailure, TrustedDeviceActions.deletefailure),
        map((action) => BaseActionTypes.ErrorAction({Payload: { ...action.Payload, ToasterMessage: errorCodesByActionTypes[action.type] }})),
        )
    )
    constructor(private graphQlEffectService: GraphQlEffectService, private actions$: Actions) {}
}
